import theme from '../../theme/news12'

import css from 'styled-jsx/css'

export default css.global`
  .slick-track {
    display: flex;
    height: max-content;
  }

  .slick-track .slick-slide {
    display: flex;
    height: auto;
  }

  .slick-dots {
    bottom: 10px;
    display: flex;
    width: 100%;
    padding: 10px 0;
  }

  .slick-dots li {
    width: 5px;
    height: 5px;
  }

  .dots{
    padding-inline-start: 0px;
  }

  .dots.news,
  .dots.weather {
    bottom: 0px;
    display: flex;
    grid-gap: 30px;
    margin: 0 auto;
  }

  .dot {
    width: 5px;
    height: 5px;
    border-radius: 7px;
    background-color: #00000000;
  }

  .dots.news li .dot {
    border: 2px solid ${theme.colors.white};
  }

  .dots.weather li .dot {
    border: 2px solid ${theme.colors.black};
  }

  .dots.news li.slick-active .dot {
    background: ${theme.colors.white};
  }

  .dots.weather li.slick-active .dot {
    background: ${theme.colors.black};
  }
`
